import styled from 'styled-components';
import {media} from '../../styles/components/media-queries';
import {ContentStyled} from '../../styles/components/content.style';
import {Link} from 'react-router-dom';

export const Wrapper = ContentStyled.extend`
  width: ${props => props.theme.basicPage.width};
  min-height: ${props => props.theme.basicPage.minHeight};
  color: ${p => p.theme.basicPage.color};
  background: ${props => props.theme.basicPage.backgroundColor};
  margin-top: ${props => props.theme.basicPage.offsetTop};
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  ${media.small`
    width: 100%;
    margin: 0;
  `};
`;

export const Info = styled.div`
  font-size: ${props => props.theme.basicPage.fontSize};
  a span {
    color: ${p => p.theme.basicPage.linkColor};
    text-decoration: underline;
  }
`;

export const Status = styled.div`
  line-height: ${props => props.theme.basicPage.status.lineHeight};
  font-size: ${props => props.theme.basicPage.status.fontSize};
  display: ${p => p.theme.basicPage.status.display};
`;

export const Sorry = styled(Status)`
  display: ${p => p.theme.basicPage.sorry.display};
`;

export const LinkStyled = styled(Link)`
  color: ${props => props.theme.tertiaryColor};
`;



// WEBPACK FOOTER //
// ./containers/NotFound/NotFound.style.js